export const queryParams = (params, key) => new URLSearchParams(params).get(key);
